import { useQuery } from "@tanstack/react-query"
import { getTextileContentNotPrinted } from "api/textile_deals/fetchTextileContentNotPrinted"

export const useTextileContentNotPrintedQuery = (textileOrderId?: number) => {
  return useQuery({
    queryKey: ['textile_content_printed', textileOrderId],
    queryFn: () => getTextileContentNotPrinted(textileOrderId!),
    enabled: !!textileOrderId
  })
}